import { useLocation, Link } from 'react-router-dom';
import { AccountSwitcher } from '@/components/navigation/AccountSwitcher';
import { BottomTabs } from '@/components/navigation/BottomTabs';
import { Sidebar } from '@/components/navigation/Sidebar';
import { AuthGuard } from '@/components/AuthGuard';

export function LayoutContent({ children }: { children: React.ReactNode }) {
  const location = useLocation();
  const pathname = location.pathname;

  // Public pages (home, auth, terms) - no dashboard chrome
  // Add additional public routes here as needed (e.g. /privacy)
  // Center auth pages specifically; keep dark background for other public pages
  if (pathname.startsWith("/auth")) {
    return (
      <div className="relative flex min-h-screen items-center justify-center bg-gradient-to-b from-zinc-950 via-zinc-900 to-black text-white">
        <Link
          to="/"
          aria-label="Back to home"
          className="absolute left-4 top-4 z-20 inline-flex items-center gap-2 rounded-md px-2 py-1 text-sm font-medium text-white/80 hover:text-white"
        >
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" className="h-4 w-4">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 19l-7-7 7-7" />
          </svg>
          <span>Home</span>
        </Link>

        {children}
      </div>
    );
  }

  if (pathname === "/" || pathname.startsWith("/terms")) {
    return (
      <div className="flex min-h-screen bg-gradient-to-b from-zinc-950 via-zinc-900 to-black text-white">
        {children}
      </div>
    );
  }

  // Dashboard pages - show header, account switcher, bottom tabs (mobile) / sidebar (desktop), and protect with AuthGuard
  return (
    <AuthGuard>
      <div className="flex min-h-screen bg-gradient-to-b from-zinc-950 via-zinc-900 to-black text-white">
        {/* Desktop Sidebar - hidden on mobile */}
        <Sidebar />
        
        {/* Main Content */}
        <div className="mx-auto flex min-h-screen w-full max-w-xl flex-col lg:ml-0 lg:max-w-none lg:flex-1">
          <header className="space-y-4 px-4 pt-6 lg:px-8">
            <div>
              <p className="text-xs uppercase tracking-[0.2em] text-white/50">
                Switch account
              </p>
              <p className="text-sm text-white/60">
                Every social profile has 3 simultaneous game slots.
              </p>
            </div>
            <AccountSwitcher />
          </header>
          <main className="flex-1 overflow-y-auto px-4 py-6 pb-28 lg:px-8 lg:pb-8">
            {children}
          </main>
          
          {/* Mobile Bottom Tabs - hidden on desktop */}
          <BottomTabs />
        </div>
      </div>
    </AuthGuard>
  );
}
